module.exports = __webpack_public_path__ + "img/add_chart.15bbc1cd.svg";